/* LAYLO 2026 theme scripts. No dependencies. */
(function () {
  'use strict';

  var config = window.LAYLO || {};
  var CART_SECTION = 'laylo-cart-drawer';
  var UPSELL_SECTION = 'laylo-cart-upsell';

  function $(selector, root) {
    return (root || document).querySelector(selector);
  }

  function $$(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  /* ---------- Reveal on scroll ---------- */

  var revealObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-in');
                revealObserver.unobserve(entry.target);
              }
            });
          },
          { rootMargin: '0px 0px -40px 0px' }
        )
      : null;

  function observeReveal(root) {
    $$('.reveal:not(.is-in)', root).forEach(function (el) {
      if (revealObserver) revealObserver.observe(el);
      else el.classList.add('is-in');
    });
  }

  /* ---------- Header ---------- */

  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;

    if (header.hasAttribute('data-transparent')) {
      var update = function () {
        header.classList.toggle('is-solid', window.scrollY > 10 || document.body.classList.contains('menu-open'));
      };
      window.addEventListener('scroll', update, { passive: true });
      update();
      header._updateSolid = update;
    }

    var menu = $('[data-mobile-menu]');
    var openBtn = $('[data-menu-open]');
    if (!menu || !openBtn) return;

    function openMenu() {
      menu.hidden = false;
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-locked', 'menu-open');
      if (header._updateSolid) header._updateSolid();
      var close = $('[data-menu-close]', menu);
      if (close) close.focus();
    }

    function closeMenu() {
      menu.hidden = true;
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-locked', 'menu-open');
      if (header._updateSolid) header._updateSolid();
      openBtn.focus();
    }

    openBtn.addEventListener('click', openMenu);
    $$('[data-menu-close]', menu).forEach(function (btn) {
      btn.addEventListener('click', closeMenu);
    });
    menu.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeMenu();
    });
  }

  /* ---------- Country and currency ---------- */

  // The customer picks a country; the store switches currency (kr for Denmark, euro elsewhere).
  // On the first visit we ask Shopify which country the visitor is in. If it is a country we ship to,
  // that country is chosen once. Everyone else stays on Denmark / kr until they choose.
  var LOC_KEY = 'laylo-loc-chosen';

  function locRemember() {
    try { localStorage.setItem(LOC_KEY, '1'); } catch (e) {}
  }

  function locChosen() {
    try { return localStorage.getItem(LOC_KEY) === '1'; } catch (e) { return true; }
  }

  function initLocalization() {
    var forms = $$('[data-loc-form]');
    if (!forms.length) return;

    forms.forEach(function (form) {
      var select = $('[data-loc-select]', form);
      if (!select) return;
      select.addEventListener('change', function () {
        locRemember();
        form.submit();
      });
    });

    var btn = $('[data-loc-btn]');
    var panel = $('[data-loc-panel]');
    if (btn && panel) {
      var setOpen = function (open) {
        panel.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      btn.addEventListener('click', function (event) {
        event.stopPropagation();
        setOpen(panel.hidden);
      });
      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
      document.addEventListener('click', function () {
        setOpen(false);
      });
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !panel.hidden) {
          setOpen(false);
          btn.focus();
        }
      });
    }

    if (locChosen() || window.Shopify && window.Shopify.designMode) return;
    var form = forms[0];
    var select = $('[data-loc-select]', form);
    fetch('/browsing_context_suggestions.json?country[enabled]=true')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        locRemember();
        var code = data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
        if (!code || !select || select.value === code) return;
        var known = Array.prototype.some.call(select.options, function (o) { return o.value === code; });
        if (!known) return;
        select.value = code;
        form.submit();
      })
      .catch(function () {});
  }

  /* ---------- Cart ---------- */

  var Cart = {
    drawer: null,
    lastFocus: null,

    init: function () {
      this.drawer = $('[data-cart-drawer]');
      if (!this.drawer) return;

      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-cart-open]');
        if (opener) {
          event.preventDefault();
          Cart.open();
          return;
        }
        if (event.target.closest('[data-cart-close]')) {
          Cart.close();
          return;
        }
        var qtyBtn = event.target.closest('[data-qty-change]');
        if (qtyBtn && Cart.drawer.contains(qtyBtn)) {
          var line = qtyBtn.closest('[data-line-key]');
          Cart.change(line, parseInt(qtyBtn.getAttribute('data-qty-change'), 10));
        }
      });

      this.drawer.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') Cart.close();
      });

      var params = new URLSearchParams(window.location.search);
      if (params.get('cart') === 'open') {
        params.delete('cart');
        var query = params.toString();
        window.history.replaceState({}, '', window.location.pathname + (query ? '?' + query : '') + window.location.hash);
        this.open();
      }
    },

    open: function () {
      var drawer = this.drawer;
      if (!drawer) return;
      if (!drawer.hidden && drawer.classList.contains('is-open')) return;
      window.clearTimeout(this.hideTimer);
      this.lastFocus = document.activeElement;
      drawer.hidden = false;
      document.body.classList.add('is-locked');
      void drawer.offsetWidth; // force layout so the slide-in transition runs
      drawer.classList.add('is-open');
      var panel = $('.drawer__panel', drawer);
      if (panel) panel.focus({ preventScroll: true });
      this.loadUpsell();
    },

    close: function () {
      var drawer = this.drawer;
      if (!drawer || drawer.hidden) return;
      drawer.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      this.hideTimer = window.setTimeout(function () {
        drawer.hidden = true;
      }, 350);
      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    render: function (sections) {
      if (!sections || !sections[CART_SECTION]) return this.refresh();
      var doc = parseHTML(sections[CART_SECTION]);
      var fresh = $('[data-cart-inner]', doc);
      var current = $('[data-cart-inner]', this.drawer);
      if (fresh && current) current.replaceWith(fresh);
      this.updateCount(fresh ? fresh.getAttribute('data-item-count') : null);
      this.loadUpsell();
    },

    refresh: function () {
      return fetch(config.routes.root + '?sections=' + CART_SECTION)
        .then(function (res) {
          return res.json();
        })
        .then(function (sections) {
          Cart.render(sections);
        });
    },

    updateCount: function (count) {
      if (count === null || count === undefined) return;
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    },

    add: function (variantId, quantity) {
      return fetch(config.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: quantity || 1 }],
          sections: CART_SECTION,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
          Cart.render(data.sections);
          Cart.open();
          return data;
        });
    },

    change: function (line, quantity) {
      if (!line) return;
      line.classList.add('is-busy');
      var error = $('[data-cart-error]', this.drawer);
      if (error) error.hidden = true;

      fetch(config.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          id: line.getAttribute('data-line-key'),
          quantity: Math.max(0, quantity),
          sections: CART_SECTION,
          sections_url: window.location.pathname
        })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw data;
            return data;
          });
        })
        .then(function (data) {
          Cart.render(data.sections);
        })
        .catch(function () {
          line.classList.remove('is-busy');
          var err = $('[data-cart-error]', Cart.drawer);
          if (err) err.hidden = false;
        });
    },

    loadUpsell: function () {
      var holder = $('[data-cart-upsell]', this.drawer);
      if (!holder || holder.getAttribute('data-loaded')) return;
      holder.setAttribute('data-loaded', 'true');
      var productId = holder.getAttribute('data-product-id');
      if (!productId) return;

      function fetchIntent(intent) {
        var url =
          config.routes.recommendations +
          '?product_id=' + encodeURIComponent(productId) +
          '&limit=10&intent=' + intent +
          '&section_id=' + UPSELL_SECTION;
        return fetch(url)
          .then(function (res) {
            return res.ok ? res.text() : '';
          })
          .then(function (html) {
            if (!html) return null;
            var results = $('[data-upsell-results]', parseHTML(html));
            return results && $('.card', results) ? results : null;
          });
      }

      fetchIntent('complementary')
        .then(function (results) {
          return results || fetchIntent('related');
        })
        .then(function (results) {
          if (results) holder.replaceChildren(results);
        })
        .catch(function () {});
    }
  };

  /* ---------- Quick add ---------- */

  function closeQuickAdds(except) {
    $$('[data-quick-add].is-open').forEach(function (qa) {
      if (qa === except) return;
      qa.classList.remove('is-open');
      var sizes = $('[data-quick-sizes]', qa);
      if (sizes) sizes.hidden = true;
      $$('[data-quick-open]', qa).forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initQuickAdd() {
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-quick-open]');
      if (opener) {
        event.preventDefault();
        var qa = opener.closest('[data-quick-add]');
        closeQuickAdds(qa);
        qa.classList.add('is-open');
        var sizes = $('[data-quick-sizes]', qa);
        if (sizes) {
          sizes.hidden = false;
          var first = $('button:not([disabled])', sizes);
          if (first) first.focus();
        }
        $$('[data-quick-open]', qa).forEach(function (btn) {
          btn.setAttribute('aria-expanded', 'true');
        });
        return;
      }

      var adder = event.target.closest('[data-add-variant]');
      if (adder && !adder.disabled) {
        event.preventDefault();
        var holder = adder.closest('[data-quick-add]');
        if (holder) holder.classList.add('is-busy');
        Cart.add(adder.getAttribute('data-add-variant'), 1)
          .then(function () {
            closeQuickAdds();
          })
          .catch(function () {})
          .then(function () {
            if (holder) holder.classList.remove('is-busy');
          });
        return;
      }

      if (!event.target.closest('[data-quick-add]')) closeQuickAdds();
    });

    document.addEventListener(
      'mouseleave',
      function (event) {
        if (!isDesktop() || !event.target.matches || !event.target.matches('.card')) return;
        var qa = $('[data-quick-add].is-open', event.target);
        if (qa && !event.target.closest('[data-cart-drawer]')) closeQuickAdds();
      },
      true
    );

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeQuickAdds();
    });
  }

  /* ---------- Product card images ---------- */

  // Desktop: second image on hover, arrows browse all images. Touch: swipe (CSS scroll-snap).
  function hydrateCard(media) {
    if (media._hydrated) return;
    media._hydrated = true;
    $$('img[data-src]', media).forEach(function (img) {
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  }

  function showCardImage(media, index) {
    var imgs = $$('.card__img', media);
    if (!imgs.length) return;
    index = ((index % imgs.length) + imgs.length) % imgs.length;
    media._index = index;
    imgs.forEach(function (img, i) {
      img.classList.toggle('is-on', i === index);
    });
    $$('.card__dots span', media).forEach(function (dot, i) {
      dot.classList.toggle('is-on', i === index);
    });
  }

  function initCardGalleries() {
    var canHover = window.matchMedia('(hover: hover)');

    document.addEventListener('mouseover', function (event) {
      if (!canHover.matches) return;
      var media = event.target.closest('[data-card-gallery]');
      if (!media || media._hover) return;
      media._hover = true;
      hydrateCard(media);
      if (!media._index) showCardImage(media, 1);
    });

    document.addEventListener('mouseout', function (event) {
      var media = event.target.closest('[data-card-gallery]');
      if (!media || media.contains(event.relatedTarget)) return;
      media._hover = false;
      showCardImage(media, 0);
    });

    document.addEventListener('click', function (event) {
      var step = event.target.closest('[data-card-step]');
      if (!step) return;
      event.preventDefault();
      var media = step.closest('[data-card-gallery]');
      hydrateCard(media);
      showCardImage(media, (media._index || 0) + Number(step.getAttribute('data-card-step')));
    });

    document.addEventListener(
      'scroll',
      function (event) {
        if (event.target.matches && event.target.matches('[data-card-slides]')) {
          hydrateCard(event.target.closest('[data-card-gallery]'));
        }
      },
      true
    );

    // Load the remaining images as soon as a finger touches a card, before the swipe starts.
    document.addEventListener(
      'touchstart',
      function (event) {
        var media = event.target.closest && event.target.closest('[data-card-gallery]');
        if (media) hydrateCard(media);
      },
      { passive: true, capture: true }
    );
  }

  /* ---------- Product page ---------- */

  function initProduct(root) {
    var jsonEl = $('[data-variants]', root);
    var form = $('[data-product-form]', root);
    if (!jsonEl || !form) return;

    var variants = JSON.parse(jsonEl.textContent);
    var groups = $$('[data-option-group]', root);
    var input = $('[data-variant-input]', root);
    var price = $('[data-price]', root);
    var lowStock = $('[data-low-stock]', root);
    var sizeMsg = $('[data-size-msg]', root);
    var buy = $('[data-buy]', root);
    var notify = $('[data-notify]', root);
    var notifyForm = $('[data-notify-form]', root);
    var notifyToggle = $('[data-notify-toggle]', root);
    var payment = $('[data-payment]', root);
    var addBtn = $('[data-add-to-cart]', root);
    var sticky = $('[data-sticky-atc]', root);
    var anyAvailable = variants.some(function (v) {
      return v.available;
    });

    var current = null;
    if (groups.length === 0) {
      current = variants[0];
    } else {
      var initial = Number(input.value);
      var preselected = groups.every(function (g) {
        return $('.size-btn.is-selected', g);
      });
      if (preselected) {
        current = variants.find(function (v) {
          return v.id === initial;
        });
      }
    }

    function selectedOptions() {
      return groups.map(function (g) {
        var btn = $('.size-btn.is-selected', g);
        return btn ? btn.getAttribute('data-option-value') : null;
      });
    }

    function update(keepUrl) {
      var showNotify = current ? !current.available : !anyAvailable;
      buy.hidden = showNotify;
      notify.hidden = !showNotify;
      if (notifyForm && !notifyForm.classList.contains('is-done')) {
        notifyForm.hidden = true;
        if (notifyToggle) {
          notifyToggle.hidden = false;
          notifyToggle.setAttribute('aria-expanded', 'false');
        }
      }

      if (current) {
        input.value = current.id;
        if (price) price.textContent = current.price;
        if (sizeMsg) sizeMsg.hidden = true;
      }
      if (payment) payment.classList.toggle('is-locked', !current);

      if (lowStock) {
        var threshold = config.lowStockThreshold || 6;
        var isLow =
          current && current.available && current.inventory !== null && current.inventory > 0 && current.inventory <= threshold;
        lowStock.hidden = !isLow;
        if (isLow) {
          // 3 up to the threshold: "Low stock". 2 or 1 left: the number, e.g. "2 left".
          lowStock.textContent =
            current.inventory <= 2
              ? lowStock.getAttribute('data-left-text').replace('[count]', current.inventory)
              : lowStock.getAttribute('data-low-text');
        }
      }

      var notifyEl = $('[data-klaviyo-form]', notify);
      var sizeLabel = current ? current.options.join(' / ') : '';
      if (notifyEl) {
        notifyEl.setAttribute('data-size', sizeLabel);
        notifyEl.setAttribute('data-variant-id', current ? current.id : '');
      }
      var note = $('[data-notify-note]', notify);
      if (note && !note.hidden) {
        note.textContent =
          current && groups.length
            ? note.getAttribute('data-size-text').replace('[size]', sizeLabel)
            : note.getAttribute('data-product-text');
      }

      if (!keepUrl && current && groups.length && root.hasAttribute('data-section-id')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', current.id);
        window.history.replaceState({}, '', url.toString());
      }
      updateSticky();
      markChart();
    }

    groups.forEach(function (group, index) {
      group.addEventListener('click', function (event) {
        var btn = event.target.closest('.size-btn');
        if (!btn) return;
        $$('.size-btn', group).forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-selected', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        var chosen = selectedOptions();
        if (chosen.indexOf(null) === -1) {
          current =
            variants.find(function (v) {
              return chosen.every(function (value, i) {
                return v.options[i] === value;
              });
            }) || null;
        } else {
          current = null;
        }
        update();
      });
    });

    function requireSize() {
      if (sizeMsg) sizeMsg.hidden = false;
      var target = groups[0];
      if (target) {
        var firstBtn = $('.size-btn', target);
        if (firstBtn) firstBtn.focus({ preventScroll: true });
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!current) {
        requireSize();
        return;
      }
      if (!current.available) return;
      addBtn.disabled = true;
      Cart.add(current.id, 1)
        .catch(function (err) {
          if (sizeMsg && err && err.description) {
            sizeMsg.textContent = err.description;
            sizeMsg.hidden = false;
          }
        })
        .then(function () {
          addBtn.disabled = false;
        });
    });

    var lock = $('[data-payment-lock]', root);
    if (lock) lock.addEventListener('click', requireSize);

    if (notifyToggle) {
      notifyToggle.addEventListener('click', function () {
        notifyForm.hidden = false;
        notifyToggle.hidden = true;
        notifyToggle.setAttribute('aria-expanded', 'true');
        var emailInput = $('input[type="email"]', notifyForm);
        if (emailInput) emailInput.focus();
      });
    }

    /* Gallery dots (mobile carousel) */
    var track = $('[data-gallery-track]', root);
    var dots = $$('[data-gallery-dot]', root);
    if (track && dots.length) {
      var raf = null;
      track.addEventListener(
        'scroll',
        function () {
          if (raf) return;
          raf = window.requestAnimationFrame(function () {
            raf = null;
            var index = Math.round(track.scrollLeft / track.clientWidth);
            dots.forEach(function (dot, i) {
              dot.classList.toggle('is-active', i === index);
            });
          });
        },
        { passive: true }
      );
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var i = Number(dot.getAttribute('data-gallery-dot'));
          track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        });
      });
    }

    /* Image zoom: full-screen overlay with every image under each other. It opens at the
       tapped image; scroll to see the rest. Close button or Escape closes it. */
    var zoom = $('[data-zoom]', root);
    if (zoom) {
      var zoomOpener = null;

      function closeZoom() {
        zoom.hidden = true;
        document.body.classList.remove('is-locked');
        if (zoomOpener) zoomOpener.focus({ preventScroll: true });
      }

      function openZoom(opener) {
        zoomOpener = opener;
        $$('img[data-src]', zoom).forEach(function (img) {
          img.src = img.getAttribute('data-src');
          img.removeAttribute('data-src');
        });
        zoom.hidden = false;
        document.body.classList.add('is-locked');
        var target = $('[data-zoom-index="' + opener.getAttribute('data-zoom-open') + '"]', zoom);
        zoom.scrollTop = target ? target.offsetTop - 56 : 0;
        updateZoomCount();
        $('[data-zoom-close]', zoom).focus({ preventScroll: true });
      }

      var zoomCount = $('[data-zoom-count]', zoom);
      var zoomItems = $$('.zoom__item', zoom).filter(function (item) {
        return item.children.length > 0;
      });
      /* Small images on the right (computer only): the one in view is marked */
      var zoomThumbs = $$('[data-zoom-thumb]', zoom);
      function updateZoomCount() {
        if (!zoomItems.length) return;
        var y = zoom.scrollTop + zoom.clientHeight / 3;
        var n = 1;
        zoomItems.forEach(function (item, i) {
          if (item.offsetTop <= y) n = i + 1;
        });
        if (zoomCount) zoomCount.textContent = n + ' / ' + zoomItems.length;
        var currentIndex = zoomItems[n - 1].getAttribute('data-zoom-index');
        zoomThumbs.forEach(function (thumb) {
          var on = thumb.getAttribute('data-zoom-thumb') === currentIndex;
          thumb.classList.toggle('is-current', on);
          if (on) {
            thumb.setAttribute('aria-current', 'true');
          } else {
            thumb.removeAttribute('aria-current');
          }
        });
      }
      zoom.addEventListener('scroll', updateZoomCount, { passive: true });

      root.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-zoom-open]');
        if (opener) {
          openZoom(opener);
          return;
        }
        var thumb = event.target.closest('[data-zoom-thumb]');
        if (thumb) {
          var target = $('[data-zoom-index="' + thumb.getAttribute('data-zoom-thumb') + '"]', zoom);
          if (target) {
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            zoom.scrollTo({ top: target.offsetTop - 56, behavior: reduce ? 'auto' : 'smooth' });
          }
          return;
        }
        if (event.target.closest('[data-zoom-close]')) closeZoom();
      });

      root.addEventListener('keydown', function (event) {
        var opener = event.target.closest('[data-zoom-open]');
        if (opener && (event.key === 'Enter' || event.key === ' ')) {
          event.preventDefault();
          openZoom(opener);
        } else if (!zoom.hidden && event.key === 'Escape') {
          closeZoom();
        }
      });
    }

    /* Size chart: panel from the right. Tapping a size in the table selects that size on the
       page, and the panel's Add to cart adds the selected size. */
    var chart = $('[data-sc]', root);
    var chartOpener = null;
    function markChart() {
      if (!chart) return;
      var size = current && groups.length ? current.options[0] : null;
      var heads = $$('thead th', chart);
      var col = -1;
      heads.forEach(function (th, i) {
        if (i > 0 && th.textContent.trim() === size) col = i;
      });
      $$('tr', chart).forEach(function (tr) {
        Array.prototype.forEach.call(tr.children, function (cell, i) {
          cell.classList.toggle('is-selected', i === col);
        });
      });
      $$('[data-sc-size]', chart).forEach(function (btn) {
        var value = btn.getAttribute('data-sc-size');
        var soldOut = !variants.some(function (v) {
          return v.options[0] === value && v.available;
        });
        btn.classList.toggle('is-sold-out', soldOut);
        btn.setAttribute('aria-pressed', value === size ? 'true' : 'false');
      });
      var add = $('[data-sc-add]', chart);
      if (current) {
        var label = size ? size + ' · ' : '';
        add.disabled = !current.available;
        add.textContent = current.available
          ? add.getAttribute('data-add-text') + ' · ' + label + current.price
          : label + add.getAttribute('data-sold-text');
      } else {
        add.disabled = true;
        add.textContent = add.getAttribute('data-add-text');
      }
    }
    function closeChart() {
      if (!chart || chart.hidden) return;
      chart.hidden = true;
      document.body.classList.remove('is-locked');
      if (chartOpener) chartOpener.focus({ preventScroll: true });
    }
    if (chart) {
      root.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-sc-open]');
        if (opener) {
          chartOpener = opener;
          markChart();
          chart.hidden = false;
          document.body.classList.add('is-locked');
          $('.sc__panel', chart).focus({ preventScroll: true });
          return;
        }
        if (chart.hidden) return;
        if (event.target.closest('[data-sc-close]')) {
          closeChart();
          return;
        }
        var cell = groups.length ? event.target.closest('.sc__table td, .sc__table thead th') : null;
        if (cell) {
          var index = Array.prototype.indexOf.call(cell.parentElement.children, cell);
          var head = $$('thead th', chart)[index];
          var sizeBtn = head && index > 0 ? $('[data-sc-size]', head) : null;
          var value = sizeBtn ? sizeBtn.getAttribute('data-sc-size') : null;
          var pageBtn = value
            ? $$('.size-btn', groups[0]).find(function (b) {
                return b.getAttribute('data-option-value') === value;
              })
            : null;
          if (pageBtn) pageBtn.click();
          return;
        }
        if (event.target.closest('[data-sc-add]') && current && current.available) {
          closeChart();
          if (form.requestSubmit) form.requestSubmit();
          else addBtn.click();
        }
      });
      chart.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeChart();
      });
    }

    /* Sticky add to cart on mobile, after scrolling past the main button */
    var pastForm = false;
    function updateSticky() {
      if (!sticky) return;
      var visible = pastForm && !buy.hidden && !isDesktop();
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      var trigger = $('[data-sticky-trigger]', sticky);
      if (trigger) trigger.tabIndex = visible ? 0 : -1;
    }

    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        pastForm = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        updateSticky();
      }).observe(buy);

      $('[data-sticky-trigger]', sticky).addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit();
        else addBtn.click();
      });
    }

    // No size chosen yet: pre-select the smallest size that is in stock (XS, then S, then M ...).
    // If everything is sold out, nothing is selected and "notify me" shows as before.
    var keepUrl = false;
    if (!current && groups.length === 1) {
      var firstAvailable = $$('.size-btn', groups[0]).find(function (btn) {
        var value = btn.getAttribute('data-option-value');
        return variants.some(function (v) {
          return v.options[0] === value && v.available;
        });
      });
      if (firstAvailable) {
        firstAvailable.classList.add('is-selected');
        firstAvailable.setAttribute('aria-pressed', 'true');
        current = variants.find(function (v) {
          return v.options[0] === firstAvailable.getAttribute('data-option-value');
        });
        keepUrl = true;
      }
    }

    update(keepUrl);
  }

  /* ---------- Product recommendations ---------- */

  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      var url = el.getAttribute('data-url');
      if (!url) return;

      function load() {
        fetch(url)
          .then(function (res) {
            return res.ok ? res.text() : '';
          })
          .then(function (html) {
            if (!html) return;
            var fresh = $('[data-recommendations]', parseHTML(html));
            if (fresh && fresh.innerHTML.trim()) {
              el.innerHTML = fresh.innerHTML;
              observeReveal(el);
            }
          })
          .catch(function () {});
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            if (entries[0].isIntersecting) {
              io.disconnect();
              load();
            }
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        io.observe(el);
      } else {
        load();
      }
    });
  }

  /* ---------- Klaviyo signup ---------- */

  // Tells Klaviyo's onsite script (Klaviyo app embed) who this visitor is after a signup,
  // so later product views and visits are tracked on their profile.
  function klaviyoIdentify(email) {
    try {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify({ email: email });
      } else {
        window._learnq = window._learnq || [];
        window._learnq.push(['identify', { $email: email }]);
      }
    } catch (e) {}
  }

  function initKlaviyo() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-klaviyo-form]');
      if (!form) return;
      event.preventDefault();

      var msg = $('.kl-form__msg', form);
      var input = $('input[type="email"]', form);
      var button = $('button[type="submit"]', form);
      var email = (input.value || '').trim();
      var listKey = form.getAttribute('data-list');
      var klaviyo = config.klaviyo || {};
      var listId = klaviyo.lists && klaviyo.lists[listKey];

      function say(text) {
        if (msg) msg.textContent = text;
      }

      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        say(msg.getAttribute('data-invalid'));
        input.setAttribute('aria-invalid', 'true');
        input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');

      var isNotify = listKey === 'notify';
      // Notify signups need at least the key (the event); newsletter signups need key and list.
      if (!klaviyo.key || (!listId && !isNotify)) {
        console.warn('LAYLO: Klaviyo public key or list ID is missing in Theme settings > Klaviyo.');
        say(msg.getAttribute('data-error'));
        return;
      }

      var endpoint = 'https://a.klaviyo.com/client/{path}/?company_id=' + encodeURIComponent(klaviyo.key);
      var headers = {
        'Content-Type': 'application/vnd.api+json',
        Accept: 'application/vnd.api+json',
        revision: '2024-10-15'
      };
      var requests = [];

      if (listId) {
        requests.push(
          fetch(endpoint.replace('{path}', 'subscriptions'), {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: form.getAttribute('data-source') || 'Website',
                  profile: { data: { type: 'profile', attributes: { email: email } } }
                },
                relationships: { list: { data: { type: 'list', id: listId } } }
              }
            })
          })
        );
      }

      // One event per notify signup, so every product a person signs up for is kept and can be segmented.
      if (isNotify) {
        requests.push(
          fetch(endpoint.replace('{path}', 'events'), {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
              data: {
                type: 'event',
                attributes: {
                  properties: {
                    product_title: form.getAttribute('data-product-title') || '',
                    product_handle: form.getAttribute('data-product-handle') || '',
                    product_type: form.getAttribute('data-product-type') || '',
                    product_family: form.getAttribute('data-product-family') || '',
                    product_url: form.getAttribute('data-product-url') || '',
                    size: form.getAttribute('data-size') || '',
                    variant_id: form.getAttribute('data-variant-id') || ''
                  },
                  metric: { data: { type: 'metric', attributes: { name: 'Notify Me Requested' } } },
                  profile: { data: { type: 'profile', attributes: { email: email } } }
                }
              }
            })
          })
        );
      }

      button.disabled = true;
      Promise.all(requests)
        .then(function (responses) {
          responses.forEach(function (res) {
            if (!res.ok) throw new Error('Klaviyo ' + res.status);
          });
          form.classList.add('is-done');
          say(msg.getAttribute('data-success'));
          klaviyoIdentify(email);
          var notifyBox = form.closest('[data-notify]');
          if (notifyBox) {
            var noteEl = $('[data-notify-note]', notifyBox);
            if (noteEl) noteEl.hidden = true;
          }
        })
        .catch(function () {
          say(msg.getAttribute('data-error'));
        })
        .then(function () {
          button.disabled = false;
        });
    });
  }

  /* ---------- Countdown (password page) ---------- */

  function tzOffset(timestamp, timeZone) {
    var parts = {};
    new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      hourCycle: 'h23',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    })
      .formatToParts(new Date(timestamp))
      .forEach(function (p) {
        parts[p.type] = p.value;
      });
    var asUTC = Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute, +parts.second);
    return asUTC - timestamp;
  }

  function zonedTimestamp(dateStr, timeStr, timeZone) {
    var d = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateStr || '');
    var t = /^(\d{1,2})[:.](\d{2})$/.exec(timeStr || '00:00');
    if (!d || !t) return NaN;
    var wall = Date.UTC(+d[1], +d[2] - 1, +d[3], +t[1], +t[2]);
    var guess = wall - tzOffset(wall, timeZone);
    return wall - tzOffset(guess, timeZone);
  }

  function initCountdown() {
    $$('[data-countdown]').forEach(function (el) {
      var target = zonedTimestamp(el.getAttribute('data-date'), el.getAttribute('data-time'), el.getAttribute('data-timezone'));
      if (isNaN(target)) {
        el.hidden = true;
        return;
      }
      var units = $('[data-countdown-units]', el);
      var live = $('[data-countdown-live]', el);
      var fields = {
        days: $('[data-days]', el),
        hours: $('[data-hours]', el),
        minutes: $('[data-minutes]', el),
        seconds: $('[data-seconds]', el)
      };

      function pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      function tick() {
        var diff = target - Date.now();
        if (diff <= 0) {
          units.hidden = true;
          live.hidden = false;
          return false;
        }
        var s = Math.floor(diff / 1000);
        fields.days.textContent = pad(Math.floor(s / 86400));
        fields.hours.textContent = pad(Math.floor((s % 86400) / 3600));
        fields.minutes.textContent = pad(Math.floor((s % 3600) / 60));
        fields.seconds.textContent = pad(s % 60);
        return true;
      }

      if (tick()) {
        var timer = window.setInterval(function () {
          if (!tick()) window.clearInterval(timer);
        }, 1000);
      }
    });
  }

  // Password page: one field at a time. "Password" swaps the email signup for the password field and back.
  function initPasswordToggle() {
    var toggle = $('[data-password-switch]');
    if (!toggle) return;
    var heading = $('[data-password-heading]');
    var label = $('[data-password-switch-label]', toggle);

    toggle.addEventListener('click', function () {
      var toCode = toggle.getAttribute('aria-expanded') !== 'true';
      toggle.setAttribute('aria-expanded', toCode ? 'true' : 'false');
      label.textContent = toggle.getAttribute(toCode ? 'data-code-label' : 'data-signup-label');
      if (heading) heading.textContent = heading.getAttribute(toCode ? 'data-code-text' : 'data-signup-text');
      $$('[data-password-code]').forEach(function (el) {
        el.hidden = !toCode;
      });
      $$('[data-password-signup]').forEach(function (el) {
        el.hidden = toCode;
      });
      var field = toCode ? $('#Password') : $('[data-password-signup] input[type="email"]');
      if (field) field.focus();
    });
  }

  /* ---------- Text pages: sections and index ---------- */

  // A heading is an h1-h4, or a paragraph that opens with bold text (how the pages are written in Shopify).
  function legalHeading(node) {
    if (node.nodeType !== 1) return null;
    if (/^H[1-4]$/.test(node.tagName)) return { title: node.textContent.trim(), rest: null };
    if (node.tagName !== 'P') return null;

    var first = null;
    for (var i = 0; i < node.childNodes.length; i++) {
      var child = node.childNodes[i];
      if (child.nodeType === 3 && !child.textContent.trim()) continue;
      if (child.nodeType === 1 && child.tagName === 'META') continue;
      first = child;
      break;
    }
    if (!first || first.nodeType !== 1 || !/^(B|STRONG)$/.test(first.tagName)) return null;

    var title = first.textContent.trim();
    if (!title || title.length > 60) return null;
    first.remove();
    while (node.firstChild && (node.firstChild.nodeName === 'BR' || node.firstChild.nodeName === 'META' || (node.firstChild.nodeType === 3 && !node.firstChild.textContent.trim()))) {
      node.firstChild.remove();
    }
    return { title: title, rest: node.textContent.trim() ? node : null };
  }

  function initLegal() {
    $$('[data-legal]').forEach(function (root) {
      var body = $('[data-legal-body]', root);
      var index = $('[data-legal-index]', root);
      if (!body || body.getAttribute('data-ready')) return;
      body.setAttribute('data-ready', 'true');

      var sections = [];
      var current = null;
      var frag = document.createDocumentFragment();

      Array.prototype.slice.call(body.childNodes).forEach(function (node) {
        if (node.nodeType === 1 && node.tagName === 'P' && !node.textContent.trim() && !node.querySelector('img')) return;
        var heading = legalHeading(node);
        if (heading) {
          current = document.createElement('section');
          current.className = 'legal__sec';
          current.id = 'section-' + (sections.length + 1);
          var h = document.createElement('h2');
          h.textContent = heading.title;
          current.appendChild(h);
          if (heading.rest) current.appendChild(heading.rest);
          frag.appendChild(current);
          sections.push({ el: current, title: heading.title });
          return;
        }
        if (!current) {
          current = document.createElement('section');
          current.className = 'legal__sec';
          frag.appendChild(current);
        }
        current.appendChild(node);
      });

      body.innerHTML = '';
      body.appendChild(frag);

      if (!index || sections.length < 3) return;
      sections.forEach(function (s) {
        var a = document.createElement('a');
        a.href = '#' + s.el.id;
        a.textContent = s.title;
        index.appendChild(a);
        s.link = a;
      });
      index.hidden = false;

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              sections.forEach(function (s) {
                s.link.classList.toggle('is-active', s.el === entry.target);
              });
            });
          },
          { rootMargin: '-20% 0px -70% 0px' }
        );
        sections.forEach(function (s) {
          io.observe(s.el);
        });
      }
    });
  }

  /* ---------- New Drop gallery ---------- */

  function initDrop() {
    $$('[data-slider]').forEach(function (slider) {
      if (slider.getAttribute('data-ready')) return;
      slider.setAttribute('data-ready', 'true');
      var track = $('[data-slider-track]', slider);
      var count = $('[data-slider-count]', slider);
      var total = track.children.length;

      function current() {
        return Math.round(track.scrollLeft / track.clientWidth);
      }

      track.addEventListener(
        'scroll',
        function () {
          if (count) count.textContent = current() + 1 + ' / ' + total;
        },
        { passive: true }
      );

      $$('[data-slider-step]', slider).forEach(function (btn) {
        btn.addEventListener('click', function () {
          var next = (current() + Number(btn.getAttribute('data-slider-step')) + total) % total;
          track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
        });
      });
    });
  }

  /* ---------- Lookbook: one collection at a time ---------- */

  function initLookbook() {
    var tabs = $('[data-lookbook-tabs]');
    var chapters = $$('[data-lookbook-chapter]');
    if (!tabs || !chapters.length) return;
    tabs.innerHTML = '';

    function show(chapter, updateUrl) {
      chapters.forEach(function (c) {
        c.classList.toggle('is-active', c === chapter);
      });
      $$('button', tabs).forEach(function (b) {
        b.setAttribute('aria-pressed', b._chapter === chapter ? 'true' : 'false');
      });
      if (updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('collection', chapter.getAttribute('data-handle'));
        window.history.replaceState({}, '', url.toString());
      }
    }

    chapters.forEach(function (chapter) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lookbook-head__tab';
      btn.textContent = chapter.getAttribute('data-name');
      btn._chapter = chapter;
      btn.addEventListener('click', function () {
        show(chapter, true);
        // Slide the chosen collection to the middle of the row (phones)
        tabs.scrollTo({ left: btn.offsetLeft - (tabs.clientWidth - btn.offsetWidth) / 2, behavior: 'smooth' });
      });
      tabs.appendChild(btn);
    });

    var wanted = new URLSearchParams(window.location.search).get('collection');
    var start = chapters.filter(function (c) {
      return c.getAttribute('data-handle') === wanted;
    })[0];
    show(start || chapters[0], false);
    if (start) {
      var startBtn = $$('button', tabs).filter(function (b) {
        return b._chapter === start;
      })[0];
      if (startBtn) tabs.scrollLeft = startBtn.offsetLeft - (tabs.clientWidth - startBtn.offsetWidth) / 2;
    }

    // Theme editor: show the collection whose section is selected.
    document.addEventListener('shopify:section:select', function (event) {
      var chapter = $('[data-lookbook-chapter]', event.target);
      if (chapter) show(chapter, false);
    });
  }

  /* ---------- Revoq withdrawal form: LAYLO styling ---------- */

  // Revoq renders its form inside a shadow root, which the theme stylesheet cannot reach.
  // Add our stylesheet inside it, and add it again if Revoq re-renders.
  function styleRevoq() {
    if (!config.revoqCss) return;
    var tries = 0;

    function apply() {
      var hosts = $$('.widerruf-form-block').filter(function (el) {
        return el.shadowRoot;
      });
      hosts.forEach(function (host) {
        var root = host.shadowRoot;
        var ensure = function () {
          if (root.querySelector('link[data-laylo]')) return;
          var link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = config.revoqCss;
          link.setAttribute('data-laylo', '');
          root.appendChild(link);
        };
        ensure();
        if (!host._layloObserved) {
          host._layloObserved = true;
          new MutationObserver(ensure).observe(root, { childList: true });
        }
      });
      return hosts.length;
    }

    (function wait() {
      if (apply() || tries++ > 40) return;
      window.setTimeout(wait, 250);
    })();
  }

  /* ---------- Init ---------- */

  /* ---------- Product page: one shared scroll ----------
     The text column is sticky. If it is taller than the screen, its top is lowered so it
     scrolls to its end first and then stays while the images carry on. */

  function initStickyInfo() {
    $$('.product__info').forEach(function (info) {
      if (info._sticky) return;
      info._sticky = true;
      var update = function () {
        if (window.innerWidth < 990) {
          info.style.top = '';
          info.style.minHeight = '';
          return;
        }
        var header = $('.header-section');
        var head = header ? header.offsetHeight : 0;
        info.style.minHeight = (window.innerHeight - head) + 'px';
        info.style.top = Math.min(head, window.innerHeight - info.offsetHeight) + 'px';
      };
      window.addEventListener('resize', update);
      if ('ResizeObserver' in window) new ResizeObserver(update).observe(info);
      update();
    });
  }

  /* ---------- Brand page: Read more ----------
     Texts taller than the set number of lines are folded, with a button to open them. */

  function initReadMore() {
    $$('[data-readmore]').forEach(function (text) {
      if (text._readmore) return;
      text._readmore = true;
      var btn = text.nextElementSibling;
      if (!btn || !btn.hasAttribute('data-readmore-btn')) return;
      var open = false;
      var check = function () {
        if (open) return;
        text.classList.add('is-folded');
        var long = text.scrollHeight > text.clientHeight + 4;
        text.classList.toggle('is-folded', long);
        btn.hidden = !long;
      };
      btn.addEventListener('click', function () {
        open = !open;
        text.classList.toggle('is-folded', !open);
        btn.setAttribute('aria-expanded', String(open));
        btn.textContent = open ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
        if (!open) check();
      });
      window.addEventListener('resize', check);
      check();
    });
  }

  function init() {
    initHeader();
    initLocalization();
    Cart.init();
    initQuickAdd();
    initCardGalleries();
    $$('[data-product]').forEach(initProduct);
    initRecommendations();
    initKlaviyo();
    initCountdown();
    initPasswordToggle();
    initLegal();
    initDrop();
    initLookbook();
    initStickyInfo();
    initReadMore();
    styleRevoq();
    observeReveal(document);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Theme editor: re-run when sections change */
  document.addEventListener('shopify:section:load', function (event) {
    observeReveal(event.target);
    $$('[data-product]', event.target).forEach(initProduct);
    initCountdown();
    initDrop();
    initLookbook();
    initReadMore();
  });
})();
